import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=6916445c&scoped=true&"
import script from "./ConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmButton.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmButton.vue?vue&type=style&index=0&id=6916445c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916445c",
  null
  
)

export default component.exports